import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';

const noop = () => {};

export const MilitaryVerificationErrorContext = createContext({
  error: null,
  setError: noop,
  clearError: noop,
});

export const MilitaryVerificationErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);
  const clearError = useCallback(() => setError(null), []);
  const value = useMemo(
    () => ({ error, setError, clearError }),
    [error, clearError],
  );

  return (
    <MilitaryVerificationErrorContext.Provider value={value}>
      {children}
    </MilitaryVerificationErrorContext.Provider>
  );
};

MilitaryVerificationErrorProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useMilitaryVerificationError = () =>
  useContext(MilitaryVerificationErrorContext);
